/* am7-pdp.js: behaviour of the 7AM Club main product section (sections/am7-pdp.liquid). Load with defer,
   after am7-base.js. No globals besides window.AM7.pdp.
     - variant state from the section's JSON (never from DOM text: the theme rewrites "colour" to "color")
     - colour / size radios -> price, availability, ADD TO CART label, ?variant= in the URL
     - gallery swap per colour (mobile carousel + desktop grid share one track), holder thumbnail, patch price
     - AJAX add to cart (theme-infra 4.2 / 5.3): optional paid name patch line FIRST, then the bundle line,
       both grouped by one id; cart drawer re-render, pub/sub + cart:refresh, /cart fallback */
(function () {
  'use strict';
  var AM7 = (window.AM7 = window.AM7 || {});

  var NAME_RE = /^(?!\s+$)[A-Za-z0-9\s]{1,12}$/;
  var NAME_KEY = 'Name Patch Text';

  function qsa(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function sizeGroup(size) { return size === 'XXS' || size === 'XS' ? 'XXS-XS' : 'S-XL'; }
  function cleanName(v) { return String(v || '').replace(/\s+/g, ' ').trim(); }

  function init(root) {
    if (!root || root.__am7Pdp) return;
    var dataEl = root.querySelector('[data-am7-pdp-json]');
    if (!dataEl) return;
    var D;
    try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
    root.__am7Pdp = true;

    var variants = D.variants || [];
    var byId = {};
    variants.forEach(function (v) { byId[v.id] = v; });
    var text = D.text || {};

    var els = {
      colourValue: root.querySelector('[data-am7-colour-value]'),
      sizeValue: root.querySelector('[data-am7-size-value]'),
      sizeShort: root.querySelector('[data-am7-size-short]'),
      colours: qsa(root, 'input[data-am7-colour]'),
      sizes: qsa(root, 'input[data-am7-size]'),
      now: root.querySelector('[data-am7-now]'),
      nowAmount: root.querySelector('[data-am7-now-amount]'),
      nowLabel: root.querySelector('[data-am7-now-label]'),
      was: root.querySelector('[data-am7-was]'),
      status: root.querySelector('[data-am7-status]'),
      atc: root.querySelector('[data-am7-atc]'),
      atcLabel: root.querySelector('[data-am7-atc-label]'),
      msg: root.querySelector('[data-am7-msg]'),
      patch: root.querySelector('[data-am7-patch]'),
      patchPrice: root.querySelector('[data-am7-patch-price]'),
      patchInput: root.querySelector('[data-am7-patch-input]'),
      patchErr: root.querySelector('[data-am7-patch-err]'),
      stage: root.querySelector('[data-am7-gallery] [data-am7-carousel]'),
      track: root.querySelector('[data-am7-gallery] [data-am7-track]'),
      galleryStatus: root.querySelector('[data-am7-gallery-status]'),
      holders: qsa(root, '[data-am7-holder]')
    };

    var start = byId[D.selected] || variants[0] || {};
    var state = { colour: start.c, size: start.s, galleryColour: start.c };
    var busy = false;

    function find(c, s) {
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].c === c && variants[i].s === s) return variants[i];
      }
      return null;
    }
    function current() { return find(state.colour, state.size); }
    function patchFor() {
      var p = D.patch && D.patch[state.colour + '|' + sizeGroup(state.size)];
      return p && p.ok ? p : null;
    }

    /* ---------- gallery ---------- */
    function renderGallery(colour) {
      var list = D.media && D.media[colour];
      if (!els.track || !list || !list.length || state.galleryColour === colour) return;
      state.galleryColour = colour;
      var keep = els.track.querySelectorAll('.am7-pdp__slide');
      var extraFrom = -1;
      // the desktop limit is server-side: reuse it (first slide with --extra marks the cut)
      for (var i = 0; i < keep.length; i++) {
        if (keep[i].classList.contains('am7-pdp__slide--extra')) { extraFrom = i; break; }
      }
      var frag = document.createDocumentFragment();
      list.forEach(function (m, i) {
        var slide = document.createElement('div');
        slide.className = 'am7-pdp__slide' + (extraFrom > -1 && i >= extraFrom ? ' am7-pdp__slide--extra' : '');
        var img = document.createElement('img');
        img.className = 'am7-pdp__img';
        img.width = 1480;
        img.height = 1480;
        img.alt = m.alt || '';
        img.decoding = 'async';
        img.loading = i < 2 ? 'eager' : 'lazy';
        img.sizes = '(min-width: 990px) min(416px, 31vw), (min-width: 750px) 600px, 100vw';
        if (m.srcset) img.srcset = m.srcset;
        img.src = m.src;
        slide.appendChild(img);
        frag.appendChild(slide);
      });
      var track = els.track;
      track.innerHTML = '';
      track.appendChild(frag);
      labelSlides();
      // back to photo 1, also when the colour changes while a smooth carousel scroll is still running
      function home() { track.scrollLeft = 0; }
      track.style.scrollSnapType = 'none';
      home();
      requestAnimationFrame(function () {
        home();
        requestAnimationFrame(function () {
          home();
          track.style.scrollSnapType = '';
          if (els.stage && AM7.carousel) {
            var car = AM7.carousel(els.stage);
            if (car) car.refresh();
          }
        });
      });
    }

    /* ---------- gallery semantics: a carousel below 990 only (>= 990 the same track is a static 2 x 2 grid) ---------- */
    var mqCarousel = window.matchMedia ? window.matchMedia('(max-width: 989.98px)') : null;
    function isCarousel() { return !mqCarousel || mqCarousel.matches; }
    function labelSlides() {
      if (!els.track) return;
      var slides = qsa(els.track, '.am7-pdp__slide');
      var on = isCarousel() && slides.length > 1;
      if (on) {
        els.track.setAttribute('aria-roledescription', 'carousel');
        els.track.setAttribute('tabindex', '0'); // keyboard scrolling (ArrowLeft/Right) in every browser
      } else {
        els.track.removeAttribute('aria-roledescription');
        els.track.removeAttribute('tabindex');
      }
      slides.forEach(function (sl, i) {
        if (on) {
          sl.setAttribute('role', 'group');
          sl.setAttribute('aria-roledescription', 'slide');
          sl.setAttribute('aria-label', (i + 1) + ' of ' + slides.length);
        } else {
          sl.removeAttribute('role');
          sl.removeAttribute('aria-roledescription');
          sl.removeAttribute('aria-label');
        }
      });
    }
    if (mqCarousel) {
      if (mqCarousel.addEventListener) mqCarousel.addEventListener('change', labelSlides);
      else if (mqCarousel.addListener) mqCarousel.addListener(labelSlides);
    }
    if (els.stage) {
      var statusTimer = 0;
      els.stage.addEventListener('am7:carousel', function (e) {
        if (!els.galleryStatus || !isCarousel() || !e.detail) return;
        var d = e.detail;
        // announce once the scroll settles (a loop from slide 1 to 10 fires an event per slide passed)
        clearTimeout(statusTimer);
        statusTimer = setTimeout(function () {
          var t = String(text.slide || 'Image [n] of [count]').replace('[n]', d.index + 1).replace('[count]', d.count);
          if (els.galleryStatus.textContent !== t) els.galleryStatus.textContent = t;
        }, 250);
      });
    }

    /* ---------- "What's My Size?" / "Size Guide": hide a button whose theme modal has no content ---------- */
    // snippets/product-size-guide renders the calculator only for listed titles/handles and the chart only with
    // the size_guide_chart metafield; an empty modal has no close control and traps keyboard users.
    qsa(root, '[data-am7-modal-btn]').forEach(function (b) {
      var m = document.getElementById(b.getAttribute('data-am7-modal-btn'));
      if (!m || !m.querySelector('.close')) b.hidden = true;
    });

    /* ---------- paint the whole state ---------- */
    function render(opts) {
      opts = opts || {};
      var v = current();

      if (els.colourValue) els.colourValue.textContent = state.colour || '';
      var names = D.sizeNames || {}, short = D.sizeShort || {};
      if (els.sizeValue) els.sizeValue.textContent = names[state.size] || state.size || '';
      if (els.sizeShort) els.sizeShort.textContent = short[state.size] || names[state.size] || state.size || '';

      els.colours.forEach(function (input) {
        input.checked = input.value === state.colour;
        var card = input.closest('.am7-pdp__swatch');
        if (card) card.classList.toggle('am7-is-checked', input.checked);
      });
      els.sizes.forEach(function (input) {
        var sv = find(state.colour, input.value);
        var ok = !!(sv && sv.ok);
        input.disabled = !ok;
        input.checked = input.value === state.size;
        var lab = input.closest('.am7-pdp__sizebtn');
        if (lab) {
          lab.classList.toggle('am7-is-soldout', !ok);
          lab.classList.toggle('am7-is-checked', input.checked);
          var so = lab.querySelector('[data-am7-size-soldout]');
          if (so) so.hidden = ok;
        }
      });

      if (v) {
        // amount only: the "Sale price" label beside it shows with a compare-at price (both prices labelled, F-27)
        if (els.nowAmount) els.nowAmount.textContent = v.p;
        else if (els.now) els.now.textContent = v.p;
        if (els.nowLabel) els.nowLabel.hidden = !v.cp;
        if (els.was) {
          els.was.hidden = !v.cp;
          var wasTxt = els.was.lastChild;
          if (wasTxt && wasTxt.nodeType === 3) wasTxt.nodeValue = v.cp || '';
          else els.was.appendChild(document.createTextNode(v.cp || ''));
        }
      }
      var buyable = !!(v && v.ok);
      // pre-order: at 0 in this market with the market's pre-order flag on, the label is the variant's message
      var pre = buyable && v.pre ? v.pre : '';
      if (els.atc) {
        els.atc.disabled = !buyable;
        if (buyable) els.atc.removeAttribute('aria-disabled'); else els.atc.setAttribute('aria-disabled', 'true');
        els.atc.classList.toggle('am7-is-preorder', !!pre);
      }
      if (els.atcLabel) els.atcLabel.textContent = pre || (buyable ? text.atc : (text.soldout || text.atc));

      // included patch: the field stays, with "Included" instead of a price
      if (els.patch && !D.patchIncluded) {
        var p = patchFor();
        els.patch.hidden = !p;
        if (els.patchPrice) els.patchPrice.textContent = p ? p.p : '';
      }

      var holder = D.holders && D.holders[state.colour];
      if (holder) {
        els.holders.forEach(function (img) {
          if (img.getAttribute('src') !== holder) img.src = holder; // decorative (alt=""): the name is beside it
        });
      }

      renderGallery(state.colour);
      showMsg('');
      if (opts.user) announceVariant(); else settled = snapshot(v);

      if (v && opts.url !== false) {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
        } catch (e) { /* old browsers: leave the URL alone */ }
      }
      if (v) root.dispatchEvent(new CustomEvent('am7:variant', { bubbles: true, detail: { variant: v } }));
    }

    /* ---------- inputs ---------- */
    root.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.matches) return;
      if (t.matches('input[data-am7-colour]') && t.checked) {
        state.colour = t.value;
        render({ user: true });
      } else if (t.matches('input[data-am7-size]') && t.checked) {
        state.size = t.value;
        render({ user: true });
      }
    });

    /* ---------- polite status (WCAG 4.1.3): add-to-cart progress and the result of a colour / size change ---------- */
    var sayTimer = 0;
    function say(m) {
      if (!els.status) return;
      clearTimeout(sayTimer);
      // cleared first, so the same words twice in a row are announced again
      els.status.textContent = '';
      if (m) sayTimer = setTimeout(function () { els.status.textContent = m; }, 60);
    }
    function snapshot(v) { return { ok: !!(v && v.ok), pre: v && v.ok && v.pre ? v.pre : '', p: v ? v.p : '', cp: v ? v.cp : '' }; }
    var settled = null; // what was on screen when the selection last settled
    var announceTimer = 0;
    function announceVariant() {
      clearTimeout(announceTimer);
      // once the selection settles (arrow keys pass through several radios), and only when something the checked
      // radio does not say has changed: not buyable, buyable again, or a new price
      announceTimer = setTimeout(function () {
        var v = current();
        var now = snapshot(v);
        var before = settled;
        settled = now;
        var changed = !before || before.ok !== now.ok || before.pre !== now.pre || before.p !== now.p || before.cp !== now.cp;
        if (now.ok && !changed) return;
        var names = D.sizeNames || {};
        var what = state.colour + ', ' + (names[state.size] || state.size) + ': ';
        if (!now.ok) say(what + (text.statusSoldout || 'sold out'));
        else if (now.pre) say(what + (text.statusPreorder || 'pre-order') + ', ' + now.pre.toLowerCase() + ', ' + now.p);
        else if (now.cp) say(what + (text.salePrice || 'sale price') + ' ' + now.p + ', ' + (text.regularPrice || 'regular price') + ' ' + now.cp);
        else say(what + now.p);
      }, 400);
    }

    function showMsg(m) {
      if (!els.msg) return;
      els.msg.textContent = m || '';
      els.msg.hidden = !m;
    }
    function nameError(m) {
      if (!els.patchInput) return;
      if (m) els.patchInput.setAttribute('aria-invalid', 'true'); else els.patchInput.removeAttribute('aria-invalid');
      if (els.patchErr && els.patchErr.textContent !== (m || '')) els.patchErr.textContent = m || '';
    }
    if (els.patchInput) {
      // checked as the customer types (the limit is on the cleaned name, so nothing is cut silently); the message
      // is already there before ADD TO CART is pressed
      els.patchInput.addEventListener('input', function () {
        var n = cleanName(els.patchInput.value);
        nameError(!n || NAME_RE.test(n) ? '' : text.nameInvalid);
      });
      // validated on ADD TO CART only: an error shown on blur would push the button down under the pointer
      // between mousedown and mouseup, and the click would be lost
      els.patchInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); if (els.atc) els.atc.click(); }
      });
    }

    /* ---------- add to cart ---------- */
    function setLoading(on) {
      busy = on;
      if (!els.atc) return;
      els.atc.classList.toggle('am7-is-loading', on);
      if (on) els.atc.setAttribute('aria-busy', 'true'); else els.atc.removeAttribute('aria-busy');
      // the spinner hides the label and aria-busy on a button is not voiced: say it (WCAG 4.1.3). The button stays
      // enabled (no aria-disabled during the request, store item U-01); a second press is ignored while busy.
      clearTimeout(announceTimer);
      say(on ? (text.adding || 'Adding to cart') : '');
    }
    function addUrl() {
      var r = window.routes && window.routes.cart_add_url;
      if (!r) r = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart/add';
      return r + '.js';
    }
    function cartUrl() { return (window.routes && window.routes.cart_url) || '/cart'; }

    function buildItems(v) {
      var gid = 'am7-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 7);
      // name patch included in the bundle (like the regular kits): ONE bundle line, the name as its first property
      // (Flat Fee shows only a line's first custom field; Bundle Mapper hands it to the patch part), then Preorder
      if (D.patchIncluded) {
        var props = {};
        var nm = els.patchInput ? cleanName(els.patchInput.value) : '';
        if (nm) props[NAME_KEY] = nm;
        if (v.ok && v.pre) props.Preorder = v.pre;
        props['_atc-sesh'] = gid;
        return [{ id: v.id, quantity: 1, properties: props }];
      }
      var patch = els.patch && !els.patch.hidden ? patchFor() : null;
      var name = patch && els.patchInput ? cleanName(els.patchInput.value) : '';
      // pre-order: same "Preorder" line property as the theme's buy buttons, on the bundle line only, first key
      // (Flat Fee shows only a line's first custom field)
      var pre = v.ok && v.pre ? v.pre : '';
      function bundleProps(p) {
        if (!pre) return p;
        var out = { Preorder: pre };
        Object.keys(p).forEach(function (k) { out[k] = p[k]; });
        return out;
      }
      if (!name) return [{ id: v.id, quantity: 1, properties: bundleProps({ '_atc-sesh': gid }) }];
      function group(step) {
        var p = { '_atc-sesh': gid };
        if (D.linkPatch) {
          p._customBundle = gid;
          p._dfc_bundle_group = gid;
          p._dfc_personalised_bundle = 'v1';
          p._dfc_bundle_step = step;
        }
        return p;
      }
      var patchProps = {};
      patchProps[NAME_KEY] = name; // first key: Flat Fee shows only a line's first custom field
      var g = group('patch');
      Object.keys(g).forEach(function (k) { patchProps[k] = g[k]; });
      // Shopify returns lines in reverse send order: the patch goes first so the bundle sits on top
      return [
        { id: patch.id, quantity: 1, properties: patchProps },
        { id: v.id, quantity: 1, properties: bundleProps(group('bundle')) }
      ];
    }

    if (els.atc) {
      els.atc.addEventListener('click', function (e) {
        e.preventDefault();
        if (busy) return;
        var v = current();
        if (!v || !v.ok) return;
        if (els.patchInput && els.patch && !els.patch.hidden) {
          var n = cleanName(els.patchInput.value);
          if (!n && D.patchIncluded) {
            nameError(text.nameRequired || text.nameInvalid);
            els.patchInput.focus();
            return;
          }
          if (n && !NAME_RE.test(n)) {
            nameError(text.nameInvalid);
            els.patchInput.focus();
            return;
          }
          nameError('');
        }
        showMsg('');
        var body = { items: buildItems(v) };
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.getSectionsToRender === 'function') {
          try {
            body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
            body.sections_url = window.location.pathname;
          } catch (err) { /* add without sections; falls back to /cart */ }
        }
        setLoading(true);
        fetch(addUrl(), {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(body)
        })
          .then(function (r) {
            return r.json().then(function (j) { return { ok: r.ok, res: j }; }, function () { return { ok: r.ok, res: {} }; });
          })
          .then(function (out) {
            var res = out.res || {};
            if (!out.ok || res.status) {
              setLoading(false);
              showMsg(res.description || res.message || text.error);
              return;
            }
            if (drawer && res.sections && typeof drawer.renderContents === 'function') {
              try {
                // focus goes back to ADD TO CART when the drawer closes (theme product-form.js does the same)
                if (typeof drawer.setActiveElement === 'function') drawer.setActiveElement(els.atc);
                drawer.classList.remove('is-empty');
                drawer.renderContents(res);
              } catch (err) {
                window.location = cartUrl();
                return;
              }
              // constants.js declares PUB_SUB_EVENTS with a top-level const: a global binding, not a window property
              if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
                try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'am7-pdp', productVariantId: v.id, cartData: res }); } catch (err) { /* ignore */ }
              }
              document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
              setLoading(false);
              if (els.patchInput) els.patchInput.value = '';
              return;
            }
            window.location = cartUrl();
          })
          .catch(function () {
            setLoading(false);
            showMsg(text.error);
          });
      });
    }

    /* ---------- accordions: PRODUCT DETAILS open on desktop, as in the design ---------- */
    if (window.matchMedia && window.matchMedia('(min-width: 990px)').matches) {
      qsa(root, 'details[data-am7-open-desktop]').forEach(function (d) { d.open = true; });
    }

    render({ url: false });
    labelSlides();
    AM7.pdp = AM7.pdp || {};
    AM7.pdp.state = function () { return { colour: state.colour, size: state.size, variant: current() }; };
  }

  function boot() { qsa(document, '.am7-pdp[data-am7-pdp]').forEach(init); }
  AM7.pdp = AM7.pdp || {};
  AM7.pdp.init = init;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target && e.target.querySelector ? e.target.querySelector('.am7-pdp[data-am7-pdp]') : null;
    if (el) init(el);
  });
})();
